"use client"

import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"
import { Alert, Box, Button } from "@mui/material"

interface PreviewBannerProps {
  isPreview: boolean
}

/**
 * Preview Mode Banner
 *
 * Displays a warning banner when preview/draft mode is active.
 * Shows at the top of the page with "Exit Preview" button.
 *
 * Only visible when isPreview = true.
 */
export function PreviewBanner({ isPreview }: PreviewBannerProps) {
  if (!isPreview) return null

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
      }}
    >
      <Alert
        severity="warning"
        sx={{
          borderRadius: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        action={
          <Button
            color="inherit"
            size="small"
            href="/api/admin/preview/disable"
            startIcon={<VisibilityOffIcon />}
            sx={{ fontWeight: "bold" }}
          >
            Exit Preview
          </Button>
        }
      >
        <strong>⚠️ Preview Mode Active</strong> - Viewing unpublished changes
      </Alert>
    </Box>
  )
}
